import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";

import { fontRoboto, setFullViewportWidthStyles, theme } from "shared/lib/styles";

type ContainerProps = {
  $variant: string;
};

export const Container = styled.div<ContainerProps>`
  ${setFullViewportWidthStyles()}
  block-size: ${props => {
    if (props.$variant === "1") return "97px";
    if (props.$variant === "0") return "39px";
    return "100%";
  }};
  max-inline-size: 1208px;
  padding-block: ${props => (props.$variant === "2" ? "0" : "12px")};
  padding-inline-start: ${props => (props.$variant === "2" ? "0" : "20px")};

  font-size: 11px;
  font-family: ${fontRoboto};
  line-height: 13px;
  border-block-end: ${props => (props.$variant === "2" ? "none" : "1px solid #333333")};

  overflow: ${props => (props.$variant === "1" ? "hidden" : "visible")};

  ${theme.breakpoints.up("tablet")} {
    inset-inline: auto;

    display: flex;
    justify-content: ${props => (props.$variant === "1" ? "flex-start" : "center")};

    inline-size: 100%;
    margin-inline: 0;
  }

  ${theme.breakpoints.up("desktop")} {
    block-size: ${props => {
      if (props.$variant === "1") return "97px";
      if (props.$variant === "0") return "47px";
      return "100%";
    }};
    padding-block: ${props => {
      if (props.$variant === "2") return "0";
      if (props.$variant === "1") return "12px";
      return "16px";
    }};
    padding-inline: ${props => {
      if (props.$variant === "2") return "0";
      if (props.$variant === "1") return "8px";
      return "20px 0";
    }};

    font-size: 12px;
    line-height: 14px;
  }
`;

const pulse = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0.4; }
  100% { opacity: 1; }
`;

export const SkeletonWrapper = styled.div`
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: center;

  inline-size: 100%;
  block-size: 39px;
  border-block-end: 1px solid #333333;

  ${theme.breakpoints.up("desktop")} {
    block-size: 47px;
  }
`;

type SkeletonBoxProps = {
  $isWide?: boolean;
};

export const SkeletonBox = styled.div<SkeletonBoxProps>`
  inline-size: ${props => (props.$isWide ? "120px" : "80px")};
  block-size: 14px;

  border-radius: 2px;

  background-color: #dfdfdf;

  animation: ${pulse} 1.5s ease-in-out infinite;
`;
